import React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";

const JournalCard = ({
  journal,
  onClick,
  showActions = false,
  onEdit,
  onDelete,
}) => {
  const imageUrl =
    journal.banner_Images?.[0]?.url_link ||
    journal.bg_Images?.[0]?.url_link ||
    "";

  const handleDelete = (e) => {
    e.stopPropagation();

    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmToast
          title="Are you sure?"
          message="You want to delete this journal?"
          onClose={onClose}
          onSuccess={() => {
            onDelete(journal);
            onClose();
          }}
        />
      ),
      overlayClassName: "!bg-gray-500 !bg-opacity-75",
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };

  return (
    <div
      className="relative bg-black rounded-lg shadow-md hover:shadow-lg 
                 transition-shadow duration-300 cursor-pointer overflow-hidden"
      onClick={() => onClick && onClick(journal)}
    >
      {/* EDIT ICON */}
      {showActions && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(journal);
          }}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center
                     rounded-full bg-black/70 backdrop-blur-md hover:bg-black/90 transition z-10"
        >
          <FiEdit2 size={16} className="text-white" />
        </button>
      )}

      <div className="relative">
        <img
          src={imageUrl}
          alt={journal.journal_title}
          className="w-full h-48 object-cover"
        />

        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 
                        text-white text-sm font-semibold p-2 truncate">
          {journal.journal_title}
        </div>
      </div>

      {/* DELETE ICON */}
      {showActions && (
        <button
          onClick={handleDelete}
          className="absolute bottom-10 right-3 w-9 h-9 flex items-center justify-center
                     rounded-full bg-black/70 backdrop-blur-md hover:bg-red-600
 transition z-10"
        >
          <FiTrash2 size={16} className="text-white" />
        </button>
      )}
    </div>
  );
};

export default JournalCard;
